"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rename = rename;
const dist_1 = require("../../core/dist");
/**
 * Renames a document = changes its human-facing **title** only.
 *
 * The permanent `id` (a content-independent ULID, e.g. `ch_01J…`) and the filename
 * are deliberately left untouched. Identity must not be re-derived from a mutable
 * title: backlinks (`parent_id`, `requires_load`, plan `blockedBy`) all reference
 * the id, and the tree view displays `title`, so a title change is fully reflected
 * without moving the file or rewriting a single reference. With the id fixed there
 * is nothing to update across the workspace — which is also why this no longer walks
 * every doc under `loom/` (that scan was what crashed on the frontmatter-free
 * `loom/refs/CLAUDE-reference.md`).
 *
 * Frontmatter title is the single source of truth; the body `# H1` is synced to match
 * (same contract as create/refine).
 */
async function rename(input, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const docPath = await deps.findDocumentById(loomRoot, input.oldId);
    if (!docPath) {
        throw new Error(`Document with ID '${input.oldId}' not found.`);
    }
    const doc = await deps.loadDoc(docPath);
    // (Draft docs are renamable: identity is the permanent ULID and the filename is
    // decoupled from the title, so there's nothing provisional to protect — the old
    // "finalize first" restriction predated stable ids and is gone.)
    const updatedDoc = {
        ...doc,
        title: input.newTitle,
        content: (0, dist_1.syncBodyH1)(doc.content ?? '', input.newTitle),
        updated: (0, dist_1.today)(),
    };
    await deps.saveDoc(updatedDoc, docPath);
    return { id: doc.id, title: input.newTitle };
}
